<template>
  <div class="project-power-company-tab">
    <AccessBlock :id="PROJECT_POWER_COMPANY_BLOCK">
      <div class="accordion" role="tablist">
        <div class="mb-3">
          <b-button
            block
            v-b-toggle.project-power-company
            variant="outline-primary"
            class="text-left accordion-header"
          >
            <i class="fa fa-bolt mr-2"></i>{{ $t('powerCompany') }}
            <i class="fa fa-chevron-down float-right mt-1"></i>
          </b-button>
          <b-collapse id="project-power-company" role="tabpanel" visible>
            <div class="accordion-content px-2 py-2">
              <ProjectPowerCompany
                v-if="powerCompanyProject"
                :blockId="PROJECT_POWER_COMPANY_BLOCK"
                :project="powerCompanyProject"
              />
            </div>
          </b-collapse>
        </div>
      </div>
    </AccessBlock>

    <AccessBlock :id="PROJECT_POWER_COMPANY_COMMUNICATION_BLOCK">
      <div class="accordion" role="tablist">
        <div class="mb-3">
          <b-button
            block
            v-b-toggle.project-power-company-communication
            variant="outline-primary"
            class="text-left accordion-header"
          >
            <i class="fa fa-envelope-o mr-2"></i>{{ $t('powerCompanyCommunication') }}
            <i class="fa fa-chevron-down float-right mt-1"></i>
          </b-button>
          <b-collapse id="project-power-company-communication" role="tabpanel" visible>
            <div class="accordion-content px-2 py-2">
              <ProjectPowerCompanyCommunication
                v-if="powerCompanyCommunicationProject"
                :blockId="PROJECT_POWER_COMPANY_COMMUNICATION_BLOCK"
                :project="powerCompanyCommunicationProject"
              />
            </div>
          </b-collapse>
        </div>
      </div>
    </AccessBlock>

    <AccessBlock :id="PROJECT_MEASUREMENT_POINT_OPERATOR_BLOCK">
      <div class="accordion" role="tablist">
        <div class="mb-3">
          <b-button
            block
            v-b-toggle.project-measurement-point-operator
            variant="outline-primary"
            class="text-left accordion-header"
          >
            <i class="fa fa-tachometer mr-2"></i>{{ $t('measurementPointOperator') }}
            <i class="fa fa-chevron-down float-right mt-1"></i>
          </b-button>
          <b-collapse id="project-measurement-point-operator" role="tabpanel" visible>
            <div class="accordion-content px-2 py-2">
              <ProjectMeasurementPointOperator
                v-if="measurementPointOperatorProject"
                :blockId="PROJECT_MEASUREMENT_POINT_OPERATOR_BLOCK"
                :project="measurementPointOperatorProject"
              />
            </div>
          </b-collapse>
        </div>
      </div>
    </AccessBlock>
  </div>
</template>

<script>
import AccessBlock from '@/components/Access/AccessBlock.vue';
import ProjectPowerCompany from '@/blocks/project/ProjectPowerCompany';
import ProjectPowerCompanyCommunication from '@/blocks/project/ProjectPowerCompanyCommunication';
import ProjectMeasurementPointOperator from '@/blocks/project/ProjectMeasurementPointOperator';
import {
  PROJECT_MEASUREMENT_POINT_OPERATOR_BLOCK,
  PROJECT_POWER_COMPANY_BLOCK,
  PROJECT_POWER_COMPANY_COMMUNICATION_BLOCK,
} from '@/navigation/accessNodes';

/** Number of the unsaved project (ProjectEdit `_new`); it has no blocks yet. */
const NEW_PROJECT_NUMBER = '_new';

/**
 * Tab EVU of the project detail (see feature page projekt-evu): one accordion section per block,
 * all open, as the tab showed everything before. Each section sits inside its `AccessBlock`, so
 * it disappears without a level and its header stays usable for readers.
 */
export default {
  name: 'ProjectPowerCompanyTab',
  components: {
    AccessBlock,
    ProjectPowerCompany,
    ProjectPowerCompanyCommunication,
    ProjectMeasurementPointOperator,
  },
  props: {
    project: { type: Object, required: true },
  },
  data() {
    return {
      PROJECT_POWER_COMPANY_BLOCK,
      PROJECT_POWER_COMPANY_COMMUNICATION_BLOCK,
      PROJECT_MEASUREMENT_POINT_OPERATOR_BLOCK,
    };
  },
  computed: {
    /** Block data of project-power-company; the unsaved project goes to the block itself. */
    powerCompanyProject() {
      return this.blockProject('powerCompany');
    },
    /** Block data of project-power-company-communication; the unsaved project goes to the block itself. */
    powerCompanyCommunicationProject() {
      return this.blockProject('powerCompanyCommunication');
    },
    /** Block data of project-measurement-point-operator; the unsaved project goes to the block itself. */
    measurementPointOperatorProject() {
      return this.blockProject('measurementPointOperator');
    },
  },
  methods: {
    blockProject(blockField) {
      if (this.project.number === NEW_PROJECT_NUMBER) {
        return this.project;
      }

      return this.project.blocks?.[blockField] ?? null;
    },
  },
};
</script>
